/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
var E;!function(E){E[E.ADD=1]="ADD",E[E.REMOVE=2]="REMOVE",E[E.MOVE=4]="MOVE"}(E||(E={}));export{E as ObservableChangesType};
